import React from "react"
import {ReactComponent as Certificate} from '../../assets/icons/certificate-7.svg'

export default function CertIcon({stone}) {
    if ((stone.lab !== 'GIA' && stone.lab !== 'GIA-LG') || stone.lightPerformance == null) return <Certificate />
    return <span className='annotated-icon'>
        <Certificate />
        +
    </span>
}